<div class="choice-plan animatedParent">
  <div class="container">
    <h2 class="text-center">Домашний интернет</h2>
    <p class="text-center">Для своих клиентов мы предлагаем гибкую сетку тарифов</p>
    <!--<li>
      <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
      <h5>Octopus 200</h5>
      <p>Скорость: до 200 мб/c</p>
      <br>
      <span><b>Стоимость</b></span>
      <div class="price">690₽<span>/месяц</span></div>
      <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
    </li>
    <li>
      <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
      <h5>Octopus 300</h5>
      <p>Скорость: до 300 мб/c</p>
      <br>
      <span><b>Стоимость</b></span>
      <div class="price">990₽<span>/месяц</span></div>
      <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
    </li>-->
    <!--===================== Nav Tabs ========================-->
    <ul class="nav nav-tabs" role="tablist">
      <li class="active"><a href="#monthly" aria-controls="monthly" role="tab" data-toggle="tab">Условия для всех клиентов</a></li>
      <li><a href="#yearly" aria-controls="yearly" role="tab" data-toggle="tab">Специальные условия</a></li>
    </ul>
    <!--===================== End of Nav Tabs ========================-->
    <div class="tab-content">
      <!--===================== Tab Monthly ========================-->
      <div role="tabpanel" class="tab-pane active" id="monthly">
        <ul class="pricing-list">
          <li class="animated bounceInLeft delay-250">
            <div class="images"><img src="assets/images/basic-plan.svg" alt="basic-plan"></div>
            <h5>Octopus 100</h5>
            <ul>
              <li>Скорость: до 100 мб/c</li>
            </ul>
            <span><b>цена</b></span>
            <div class="price">390₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
          </li>
          <li class="animated bounceInLeft delay-550">
            <div class="images"><img src="assets/images/star-plan.png" alt="star-plan"></div>
            <h5>Octopus 200</h5>
            <ul>
              <li>Скорость: до 200 мб/c</li>
            </ul>
            <span><b>Стоимость</b></span>
            <div class="price">690₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
          </li>
          <li class="animated bounceInLeft delay-750">
            <div class="images"><img src="assets/images/hosting.svg" alt="line-plan"></div>
            <h5>Octopus 300</h5>
            <ul>
              <li>Скорость: до 300 мб/c</li>
            </ul>
            <span><b>Стоимость</b></span>
            <div class="price">990₽<span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
          </li>
        </ul><!--pricing-list-->
      </div>
      <!--===================== End of Tab Monthly ========================-->
      <!--===================== Yearly ========================-->
      <div role="tabpanel" class="tab-pane" id="yearly">
        <ul class="pricing-list">
          <li>
            <div class="images"><img src="assets/images/basic-plan.svg" alt="hosting"></div>
            <h5>«Выгодный переход» </h5>
            <p>Скорость: до 50 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">100₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn text-white">Начать</a>
            <!--<a href="javascript:void(0)" (click)="openPopupTV('prosto')" class="custom-btn btn btn-outline-info">Список каналов</a>-->
            <app-special-price></app-special-price>
          </li>
          <!-- <li class="animated bounceInLeft delay-250">
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>Стартовый +</h5>
            <p>Подойдет для опытных пользователей</p>
              <br>
            <span><b>Стоимость</b></span>
            <div class="price">200₽<span>/месяц</span></div>
            <a href="service-page.html" class="custom-btn">Начать</a>
          </li> -->
          <li>
            <div class="images"><img src="assets/images/star-plan.png" alt="hosting"></div>
            <h5>«Выгодный переход +1»</h5>
            <p>Скорость: до 75 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">150₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <!--<a href="javascript:void(0)" (click)="openPopupTV('light')" class="custom-btn btn btn-outline-info">Список каналов</a>-->
            <app-special-price></app-special-price>
          </li>
          <li>
            <div class="images"><img src="assets/images/hosting.svg" alt="hosting"></div>
            <h5>«Выгодный переход +2»</h5>
            <p>Скорость: до 100 мб/c</p>
            <br>
            <span><b>Стоимость</b></span>
            <div class="price">200₽<sup>*</sup><span>/месяц</span></div>
            <a href="javascript:void(0)" (click)="openPopup()" class="custom-btn btn-link text-white">Начать</a>
            <!--<a href="javascript:void(0)" (click)="openPopupTV('base')" class="custom-btn btn btn-outline-info">Список каналов</a>-->
            <app-special-price></app-special-price>
          </li>
        </ul><!--pricing-list-->
      </div>
      <!--===================== End of Tab Yearly ========================-->
    </div><!--tab-content-->
  </div><!--container-->
</div>
